import { SetOperator } from "../operator/operator3D.helper";
import * as Communicator from "@ts3d-hoops/web-viewer";

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
type Point2 = Communicator.Point2;
type Point3 = Communicator.Point3;
export default class WalkKeyboardOperator extends Communicator.Operators.Camera
    .CameraKeyboardWalkOperator {
    setOperator!: SetOperator;
    test!: Communicator.Operators.Camera.CameraPanOperator;
    viewer: Communicator.IWebViewer;
    isHandleFocus = false;
    top = 0;
    left = 0;
    public onWell = false;
    originWalkSpeed = 0;
    originZoomSpeed = 0;
    speedRegulationCoefficient = 0.1;
    constructor(viewer: Communicator.IWebViewer) {
        super(viewer, viewer.view);
        this.viewer = viewer;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onKeyUp(event: Communicator.Event.KeyInputEvent) {
        super.onKeyUp(event);
    }

    onKeyDown(event: Communicator.Event.KeyInputEvent) {
        this.updateSpeed();
        super.onKeyDown(event);
    }
    async onMouseDown(event: Communicator.Event.MouseInputEvent) {
        this.updateSpeed();
        const opeHandle = this.viewer.operatorManager.getOperator(
            Communicator.OperatorId.Handle
        ) as Communicator.Operators.HandleOperator;
        // eslint-disable-next-line no-underscore-dangle
        if (opeHandle && (opeHandle as any)._highlightedHandleId) {
            this.isHandleFocus = true;
        } else {
            this.top = event.getPosition().y;
            this.left = event.getPosition().x;
            this.isHandleFocus = false;
        }
        super.onMouseDown(event);
    }
    async onMouseUp(event: Communicator.Event.MouseInputEvent) {
        this.top = 0;
        this.left = 0;
        await this.resetCameraTarget();
    }
    onMouseMove(event: Communicator.Event.MouseInputEvent) {
        this.updateSpeed();
        this.viewer.delayCapping();
        const topCurrent = event.getPosition().y;
        const leftCurrent = event.getPosition().x;
        let differenceTop = 0;
        let differenceLeft = 0;
        differenceLeft = Math.abs(leftCurrent - this.left);
        differenceTop = Math.abs(topCurrent - this.top);
        this.onWell = false;
        if (!this.isHandleFocus) {
            if (event.getButtons() === Communicator.Buttons.Middle) {
                this.onWell = true;
            } else if (event.getButtons() === Communicator.Buttons.Left) {
                setTimeout(() => {
                    if (differenceTop - differenceLeft > 3) {
                        if (this.top !== 0 && this.top < topCurrent) {
                            this.walkBackward(this.getWalkSpeed());
                            this.top = topCurrent;
                        } else if (this.top !== 0 && this.top > topCurrent) {
                            this.walkForward(this.getWalkSpeed());
                            this.top = topCurrent;
                        }
                    } else if (differenceLeft - differenceTop > 3) {
                        this.viewer.delayCapping();
                        if (this.left !== 0 && leftCurrent - this.left > 3) {
                            this.rotateLeft(this.getRotationSpeed() / 50);
                            this.left = leftCurrent;
                        } else if (
                            this.left !== 0 &&
                            this.left - leftCurrent > 3
                        ) {
                            this.rotateRight(this.getRotationSpeed() / 50);
                            this.left = leftCurrent;
                        }
                    }
                }, 100);
            } else if (event.getButtons() === Communicator.Buttons.Right) {
                super.onMouseMove(event);
            }
        }
    }

    async onMousewheel(event: Communicator.Event.MouseWheelInputEvent) {
        this.updateSpeed();
        if (this.onWell) return;
        else {
            setTimeout(async () => {
                await this.resetCameraTarget();
            }, 100);
            const reverseScrollEvent =
                new Communicator.Event.MouseWheelInputEvent(
                    event.getPosition().x,
                    event.getPosition().y,
                    event.getWheelDelta() * -1,
                    event.getButtons(),
                    event.getModifiers(),
                    event.getEventType(),
                    this.viewer.view.id
                );
            super.onMousewheel(reverseScrollEvent);
        }
    }

    private createBeginConfig(
        min: Point2,
        max: Point2,
        mustBeFullyContained: boolean
    ): any {
        const config = new Communicator.IncrementalPickConfig();
        config.forceEffectiveSceneVisibilityMask =
            Communicator.SelectionMask.None;
        config.ignoreCuttingSections = false;
        config.ignoreUnrequestedInstances = true;

        if (mustBeFullyContained) {
            config.mustBeFullyContained = true;
        }

        return { pickConfig: config, areaCssMin: min, areaCssMax: max };
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getNodeIds(list: any[]): number[] {
        return list.map((item) => item.getNodeId());
    }

    fixCameraTarget(func: string, point: Point3) {
        const camera = this.viewer.view.getCamera();
        const pos = camera.getPosition();
        const len = pos.copy().subtract(point).length();
        const dir = pos.copy().subtract(camera.getTarget()).normalize();
        const newTarget = pos.add(dir.scale(-len));
        camera.setTarget(newTarget);
        this.viewer.view.updateCamera(camera);
    }

    private async resetCameraTarget2(): Promise<void> {
        this.viewer.model
            .getNodesBounding([this.viewer.model.getAbsoluteRootNode()])
            .then((box) => {
                const cam = this.viewer.view.getCamera();
                const vecPosTar = Communicator.Point3.subtract(
                    cam.getTarget().copy(),
                    cam.getPosition().copy()
                );
                const plan = Communicator.Plane.createFromPointAndNormal(
                    box.center(),
                    vecPosTar.normalize()
                );
                const ray = new Communicator.Ray(
                    cam.getTarget().copy(),
                    vecPosTar
                );
                if (ray) {
                    const outPoin3: Communicator.Point3 =
                        Communicator.Point3.zero();
                    plan.intersectsRay(ray, outPoin3);
                    // eslint-disable-next-line no-debugger
                    debugger;
                    this.fixCameraTarget("fix target Ray:", outPoin3);
                }
            });
    }

    private createSphereMesh(
        position: Communicator.Point3,
        color: Communicator.Color
    ) {
        const sphereMeshData = Communicator.Util.generateSphereMeshData();
        const translationMatrix = new Communicator.Matrix();
        const translationScale = 0.01;
        translationMatrix.setTranslationComponent(
            position.x,
            position.y,
            position.z
        );
        translationMatrix.setScaleComponent(
            translationScale,
            translationScale,
            translationScale
        );
        this.viewer.model.createMesh(sphereMeshData).then((meshId) => {
            const meshInstanceData = new Communicator.MeshInstanceData(meshId);
            meshInstanceData.setMatrix(translationMatrix);
            meshInstanceData.setFaceColor(color);
            meshInstanceData.setCreationFlags(
                Communicator.MeshInstanceCreationFlags.SuppressCameraScale
            );
            this.viewer.model.createMeshInstance(meshInstanceData);
        });
    }

    private async resetCameraTarget(): Promise<void> {
        this.viewer.model
            .getNodesBounding([this.viewer.model.getAbsoluteRootNode()])
            .then((box) => {
                this.fixCameraTarget("fix target Ray:", box.center());
            });
    }

    async onDeactivate() {
        await this.resetCameraTarget();
        this.setWalkActive(false);
    }

    updateSpeed() {
        const currentWalkSpeed = this.getWalkSpeed();
        const currentZoomSpeed = this.getZoomSpeed();
        if (this.originWalkSpeed === 0) {
            this.originWalkSpeed = currentWalkSpeed;
        }
        if (this.originZoomSpeed === 0) {
            this.originZoomSpeed = currentZoomSpeed;
        }

        const newWalkSpeed =
            this.originWalkSpeed * this.speedRegulationCoefficient;
        if (currentWalkSpeed !== newWalkSpeed) {
            this.setWalkSpeed(newWalkSpeed);
        }

        const newZoomSpeed =
            this.originZoomSpeed * this.speedRegulationCoefficient;
        if (currentZoomSpeed !== newZoomSpeed) {
            this.setZoomSpeed(newZoomSpeed);
        }
    }
}
